import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout";
import { Helmet } from "react-helmet";
import useSiteMetadata from '../components/use-site-metadata';
import { Scrollbar } from "react-scrollbars-custom";
import VideoModal from "../components/video-modal";
import LinkCustom from '../components/TransitionLinks/LinkCustom';
import StoryNav from '../components/story-nav';

export default function Template({
  data
}) {

  const { siteUrl } = useSiteMetadata();

  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  
  // var tags = frontmatter.tags.slice(1).map(function(tag){
  //   var path = '/' + tag.replace(/\s+/g, '-').toLowerCase();
  //   if (tag !== 'featured') {
  //     return (
  //       <Link to={path} className="tag">{tag}</Link>
  //     )
  //   } else {
  //     return null;
  //   }
  // })
  
  // if (frontmatter.goalAmount) {
  //   var goal = <span className="goal">{frontmatter.goalAmount}</span>;
  // } else {
  //   goal = null;
  // }

  var pageClass = frontmatter.path;
  pageClass = pageClass.split("/").pop();


  // var desc = html.replace(/(<([^>]+)>)/ig,"");

  function AntiRacismIsafter() {
    if (frontmatter.antiRacismIsafter) {
      return <small>{frontmatter.antiRacismIsafter}</small>
    } else {
      return null
    }
  }

  function InlineImage() {
    if (frontmatter.inlineImage) {
      return <figure><img src={frontmatter.inlineImage.publicURL} alt={frontmatter.name} /></figure>
    } else {
      return null
    }
  }

  var firstHalf = (html.split('</p>')
    .splice(0,4)
    .join('</p>') +
    '</p>'
   ).replace(/\<\/p> *\<\/p>/g,'</p>');

  var secondHalf = (html.split('</p>')
    .slice(4)
    .join('</p>') +
    '</p>'
   ).replace(/\<\/p> *\<\/p>/g,'</p>');
    
  return (
    <Layout>
      <Helmet>
        <title>{frontmatter.title}</title>

        <link rel="canonical" href={`${siteUrl}${frontmatter.path}`} />
        <meta name="description" content={frontmatter.antiRacismIs} />

        {/* Schema.org markup for Google+ */}
        <meta itemprop="name" content={frontmatter.title} />
        <meta itemprop="description" content={frontmatter.antiRacismIs} />
        <meta itemprop="image" content={frontmatter.thumbnailImage.publicURL} />

        {/* Twitter Card data */}
        <meta name="twitter:title" content={frontmatter.title} />
        <meta name="twitter:description" content={frontmatter.antiRacismIs} />
        <meta name="twitter:image:src" content={frontmatter.thumbnailImage.publicURL} />

        {/* Open Graph data */}
        <meta property="og:title" content={frontmatter.title} />
        <meta property="og:url" content={`${siteUrl}${frontmatter.path}`} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1000" />
        <meta property="og:image:height" content="562" />
        <meta property="og:image" content={frontmatter.thumbnailImage.publicURL} />
        <meta property="og:image:alt" content={frontmatter.title} />
        <meta property="og:description" content={frontmatter.antiRacismIs} />
      </Helmet>
      <section id="post-container" className={"page-content-wrapper post " + pageClass}>
        <div className="post-image" style={{ backgroundImage: `url(${frontmatter.featuredImage.publicURL})` }}>
          <VideoModal vimeoID={frontmatter.vimeoID} title={`${'Watch '}${frontmatter.name}${'\'s story'}`} />
        </div>
        <div className="post-content">
          <Scrollbar style={{ height: '100%' }} >
            <LinkCustom effect="fadeUp" length={2} url="/all-stories" className="back-button">
              <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" role="img" aria-labelledby="back-arrow-title">
                <title id="back-arrow-title">Back Arrow</title>
                <path role="presentation" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"/>
              </svg>
              Back to All Stories
            </LinkCustom>
            <h1>{frontmatter.name}</h1>
            <span className="post-sub-head">{frontmatter.bullets[0]}</span>

            <span className="anti-racism-is-label">Anti-racism is:</span>
            <blockquote className="anti-racism-is">
              <p>“{frontmatter.antiRacismIs}”</p>
              <AntiRacismIsafter />
            </blockquote>

            <h2>{frontmatter.title}</h2>

            {/* <div dangerouslySetInnerHTML={{ __html: html }} /> */}

            <div dangerouslySetInnerHTML={{ __html: firstHalf }} />

            <InlineImage />

            <div dangerouslySetInnerHTML={{ __html: secondHalf }} />

            <StoryNav currentPath={frontmatter.path} />
          </Scrollbar>
        </div>
        
      </section>
     
    </Layout>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        featuredImage{
          publicURL
        }
        thumbnailImage{
          publicURL
        }
        inlineImage{
          publicURL
        }
        path
        title
        tags
        name
        vimeoID
        antiRacismIs
        antiRacismIsafter
        bullets
      }
    }
  }
`